import type {
  Control,
  FieldValues,
  Path,
  RegisterOptions,
} from 'react-hook-form';
import LabelT from '../Label/LabelT';
import SelectInputT from './SelectInputT';

type SelectWithLabelProps<T extends FieldValues> = {
  field?: Path<T>;
  options?: RegisterOptions<T>;
  values: Array<{
    value: string;
    description?: string;
    optionProps?: React.OptionHTMLAttributes<HTMLOptionElement>;
  }>;
  control?: Control<T>;
  label: string;
  labelClassName?: string;
  noOptionSelectedText?: string;
  selectInputParentClassName?: string;
  error?: string;
} & React.DetailedHTMLProps<
  React.SelectHTMLAttributes<HTMLSelectElement>,
  HTMLSelectElement
>;

export function SelectInputWithLabelT<T extends FieldValues>({
  field,
  options,
  values,
  control,
  label,
  labelClassName = '',
  noOptionSelectedText,
  selectInputParentClassName = '',
  error,
  ...restParams
}: SelectWithLabelProps<T>) {
  return (
    <>
      <LabelT text={label} className={labelClassName} />
      <div className='mt-1'>
        <SelectInputT
          field={field}
          control={control}
          options={options}
          values={values}
          noOptionSelectedText={noOptionSelectedText}
          parentClassName={`mb-2 ${selectInputParentClassName}`}
          error={error}
          {...restParams}
        />
      </div>
    </>
  );
}

export default SelectInputWithLabelT;
